import { useRef, useEffect } from "react";
import CustomButton from "@/src/lib/ui/Button";
import CustomIconButton from "@/src/lib/ui/iconButton";
import Iconify from "../../iconify";
import IconCode from "@/src/lib/iconCode";
import ShowCartVisitWise from "./showCartVisitWise";
import Progressbar from "../../loading";
import NoTestFoundInCart from "./noTestFoundInCart";
import { useRouter } from "next/router";
import useBreakpoint from "@/src/lib/util/custom-hooks/useBreakPoint";

const CartDrawerForLoggedInCart = ({
    anchorEl,
    handleClose,
    homeCart,
    centreCart,
    refetchCheckoutData,
    showLoader,
    checkoutData,
}) => {
    const { push } = useRouter();
    const drawerRef = useRef(null);
    const isMobile = useBreakpoint("sm");

    // Prevent body scroll when drawer is open
    useEffect(() => {
        if (anchorEl) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "unset";
        }

        // Cleanup function to restore body scroll when component unmounts
        return () => {
            document.body.style.overflow = "unset";
        };
    }, [anchorEl]);

    const cartHandler = () => {
        push("/cart");
        handleClose();
    };

    const findTest = () => {
        push("/find-a-test");
        handleClose();
    };

    return (
        <>
            {/* Backdrop */}
            <div
                className={`fixed inset-0 bg-black transition-opacity duration-300 ease-in-out z-40  ${
                    anchorEl ? "bg-black/50 visible" : "bg-black/0 invisible"
                }`}
                onClick={handleClose}
            />

            {/* Drawer - Responsive width using Tailwind */}
            <div
                ref={drawerRef}
                className={`fixed top-0 right-0 h-full bg-slate-100 z-50 transform transition-transform duration-300 ease-in-out shadow-2xl ${
                    anchorEl ? "translate-x-0" : "translate-x-full"
                } ${isMobile ? "w-full" : "w-[360px]"}`}
                style={{
                    boxShadow: anchorEl
                        ? "0 25px 50px -12px rgba(0, 0, 0, 0.25)"
                        : "none",
                }}
            >
                <div
                    style={{ height: "calc(100vh - 70px)" }}
                    className="overflow-y-auto p-4"
                >
                    <div className="flex flex-row justify-between items-center">
                        <div className="flex flex-row justify-between items-center">
                            <CustomIconButton
                                onClick={handleClose}
                                className="w-8 h-8 flex items-center justify-center p-0 mr-1 hover:bg-gray-200 transition-colors duration-200"
                            >
                                <Iconify
                                    icon={IconCode.arrowDown}
                                    width="32px"
                                    className="text-primary rotate-90"
                                />
                            </CustomIconButton>

                            <h4 className="text-black font-bold text-base">
                                Cart
                            </h4>
                        </div>
                    </div>

                    {showLoader ? (
                        <div className="flex flex-row justify-center items-center">
                            <Progressbar size={40} />
                        </div>
                    ) : centreCart?.data?.[0]?.patients?.length > 0 ||
                      homeCart?.data?.[0]?.patients?.length > 0 ? (
                        <>
                            <ShowCartVisitWise
                                visitWise={centreCart}
                                heading="Centre Visit"
                                refetchCheckoutData={refetchCheckoutData}
                                findTest={cartHandler}
                                checkoutData={checkoutData}
                                isCentreCart={true}
                                handleClose={handleClose}
                            />
                            <ShowCartVisitWise
                                visitWise={homeCart}
                                heading="Home Collection"
                                refetchCheckoutData={refetchCheckoutData}
                                findTest={cartHandler}
                                checkoutData={checkoutData}
                                handleClose={handleClose}
                                isCentreCart={false}
                            />
                        </>
                    ) : (
                        <NoTestFoundInCart findTest={findTest} />
                    )}
                </div>
                <div className="w-full px-4">
                    <CustomButton
                        fullwidth
                        variant="contained"
                        className="w-full"
                        onClick={cartHandler}
                    >
                        Proceed to Checkout
                    </CustomButton>
                </div>
            </div>
        </>
    );
};

export default CartDrawerForLoggedInCart;
